import type { SubscriptionStatus } from '@moniebook-web/types';

export interface SubscriptionStatusDetails {
    status: SubscriptionStatus;
    subscriptionEndDate: string | null;
    accountLinked: boolean;
    active: boolean;
}

export enum BannerType {
    ERROR = 'error',
    WARN = 'warning',
    SUCCESS = 'success',
    INFO = 'info',
}

export interface BannerInfo {
    id: string;
    completed: boolean;
    type: BannerType;
    message: string;
    label: string;
    link: string;
    endDate?: string | null;
}
